export default "__VITE_ASSET__DHer_poM__"